export const ACCEPTED_NECESSARY_COOKIES = 'acceptedNecessaryCookies';
